/*
  Read more collapse for mobile
*/
window.addEventListener("load", function () {
    if (!window.location.href.includes("collection") || window.innerWidth >= 768) {
        console.log("Script not applicable for this page or screen size.");
        return;
    }
    function addReadMoreIfNeeded(selector) {
        const element = document.querySelector(selector);
        if (!element) return;
        const lineHeight = parseFloat(getComputedStyle(element).lineHeight);
        if (element.offsetHeight > lineHeight * 2) {
            const readMoreButton = document.createElement("button");
            readMoreButton.textContent = "Læs mere";
            readMoreButton.classList.add("read-more-link");
            readMoreButton.id = "toggle-prose";
            element.parentNode.insertBefore(readMoreButton, element.nextSibling);
            readMoreButton.addEventListener("click", () => {
                element.classList.toggle("expanded") ? (readMoreButton.textContent = "Læs mindre") : (readMoreButton.textContent = "Læs mere");
            });
        }
    }
    addReadMoreIfNeeded(".collection-header .prose");
    console.log("Toggle read more");
});
